import { render, staticRenderFns } from "./TeacherChoose.vue?vue&type=template&id=4380aa94&scoped=true&"
import script from "./TeacherChoose.vue?vue&type=script&lang=js&"
export * from "./TeacherChoose.vue?vue&type=script&lang=js&"
import style0 from "./TeacherChoose.vue?vue&type=style&index=0&id=4380aa94&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4380aa94",
  null
  
)

export default component.exports